// extracted by mini-css-extract-plugin
export var divider = "_ri-0";
export var systemMessage = "_ri-1";
export var systemMessageWrapper = "_ri-2";